module.exports = __webpack_public_path__ + "img/trash-document.ca59cca9.svg";